
import { computed, ComputedRef, defineComponent } from "vue";
import { User } from "../../../domain/entities/entities";
import { useStore } from "vuex";

export default defineComponent({
  name: "Maintenance",
  setup() {
    const store = useStore();

    /** User getter.
     * @see User. */
    const user: ComputedRef<User> = computed(() => {
      return store.getters["userProfile_module/user"];
    });

    return {
      user
    };
  }
});
